@if (!!_selectorSelection?.senderId) {
  <email-domain-authorization [senderType]="_selectorSelection.senderType" [senderID]="_selectorSelection.senderId" />
} @else {
  <glxy-empty-state>
    <glxy-empty-state-hero>
      <mat-icon>search</mat-icon>
    </glxy-empty-state-hero>
    <glxy-empty-state-title>Choose a sender ID above</glxy-empty-state-title>
    <p>The domain records for that sender will load here</p>
  </glxy-empty-state>
}

